import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHyundaiComponent } from './simple-icons-hyundai.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHyundaiComponent ],
    exports:      [ SimpleIconsHyundaiComponent ],
    bootstrap:    []
})
export class SimpleIconsHyundaiModule {}
